import { apiClient } from '../../base/ApiClients'
import { RegisterInfoFormValues } from '../../../models/b2b/RegisterInfo'
import { useMutation } from 'react-query'

export async function registerInfo(values: RegisterInfoFormValues) {
  return await apiClient.post('/b2b/registerinfo', values);
}

export const useRegisterInfoMutation = () => useMutation(registerInfo, {});
